import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-internetconnectivity',
  templateUrl: './internetconnectivity.component.html',
  styleUrls: ['./internetconnectivity.component.scss']
})
export class InternetconnectivityComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
